import {DailyActiveUser} from '../dto/usage-data.dto';
import moment from 'moment-timezone';
import {IUsageDateType} from 'interfaces/interface';
import {ExcelStyleGroupTitleAndTextValueDto} from '../dto/excel-styles.dto';

/**
 * 사용자수 리스트 생성 함수
 * @param startRow - 시작할 row 번호
 * @param usageList - 사용량 리스트
 * @param dateType - 날짜 타입
 * @returns 사용량 엑셀 스타일 리스트
 * @public
 */
export function makeUsageList(
  startRow: number,
  usageList: DailyActiveUser[],
  dateType: IUsageDateType,
): ExcelStyleGroupTitleAndTextValueDto[] {
  const result = [];

  for (let i = 0; i < usageList.length; i++) {
    const signingTitle = {
      categoryCell: {
        mergeRange: `A${startRow + i}:C${startRow + i}`,
        cellValue: moment(usageList[i].date).format(
          dateType === 'daily'
            ? 'YYYY-MM-DD'
            : dateType === 'monthly'
            ? 'YYYY-MM'
            : 'YYYY',
        ),
        fillColor: 'd8d8d8',
        fontSize: 15,
      },
      textValueCell: {
        mergeRange: `D${startRow + i}:E${startRow + i}`,
        cellValue: usageList[i].activeUsers.toString(),
        fontSize: 15,
      },
    };
    result.push(signingTitle);
  }
  return result;
}
